import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
const MIGRATION_MODE = 2;
export async function validate360User(pin, token) {
    const tokenV3 = store.state.auth.tokenV3;
    return await axios({
        method: 'POST',
        url: '/auth/validateCRM360',
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            pin,
            token,
            mode: MIGRATION_MODE,
        },
    }).then(response => response.data);
}
export async function create360User(userPayload) {
    const { id, email, nickname, accessToken } = userPayload;
    return await axios({
        method: 'POST',
        url: '/user/createUserCRM360',
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${accessToken}` },
        params: {
            id,
            email,
            nickname,
            mode: MIGRATION_MODE,
        },
    }).then(response => response?.data);
}
